import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
function App() {
  AOS.init();
  return (
    <div className="App">
      <div className="container">
        <div className="col-12">
          <div className="row">
            {/* Tecg Prism SVG */}
            <div className="col-lg-6">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 1000 1000"
              >
                <g transform="matrix(0.7,0,0,0.7,149.57575757575756,282.1265587044535)">
                  <svg
                    viewBox="0 0 396 247"
                    data-background-color="#051726"
                    preserveAspectRatio="xMidYMid meet"
                   
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <defs></defs>
                    <g
                      id="tight-bounds"
                      transform="matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
                    >
                      <svg
                        viewBox="0 0 395.52 247.2"
                        
                      >
                        <g>
                          <svg></svg>
                        </g>
                        <g>
                          <svg
                            viewBox="0 0 395.52 247.2"
                           
                          >
                            <g transform="matrix(3.020969357781435, 0, 0, 3.020969357781435, 46.71153211092823, 1)">
                              <svg
                                 version="1.1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 xmlnsXlink="http://www.w3.org/1999/xlink"
                                x="0"
                                y="0"
                                viewBox="0 0 100 81.16600036621094"
                                enable-background="new 0 0 100 81.166"
                                width="100"
                                height="81.16600036621094"
                                class="icon-none"
                                data-fill-palette-color="accent"
                                id="none"
                              >
                                <path
                                  d="M87.043 0H50 12.957L0 23.557l50 57.609 50-57.609L87.043 0zM83.635 6.345l7.59 13.801h-13.64L83.635 6.345zM77.168 6.043l-5.537 12.636L57.792 6.043H77.168zM64.273 20.146H50 35.727L50 7.113 64.273 20.146zM42.208 6.043L28.37 18.679 22.832 6.043H42.208zM16.365 6.345l6.05 13.801H8.775L16.365 6.345zM10.288 26.189h14.776l15.078 34.399L10.288 26.189zM31.663 26.189H50h18.338L50 68.022 31.663 26.189zM59.857 60.589l15.078-34.399h14.777L59.857 60.589z"
                                  fill="#81ffd9"
                                  data-fill-palette-color="accent"
                                ></path>
                              </svg>
                            </g>
                            <rect
                              width="348.05760000000004"
                              height="72.96808021839118"
                              fill="#051726"
                              y="87.1159598908044"
                              x="23.731199999999973"
                              data-fill-palette-color="quaternary"
                            ></rect>
                            <g transform="matrix(1,0,0,1,39.55199999999999,98.81720575783234)">
                              <svg
                                viewBox="0 0 316.416 49.5655884843353"
                                height="49.5655884843353"
                                width="316.416"
                              >
                                <g>
                                  <svg
                                    viewBox="0 0 316.416 49.5655884843353"
                                    height="49.5655884843353"
                                    width="316.416"
                                  >
                                    <g>
                                      <svg
                                        viewBox="0 0 316.416 49.5655884843353"
                                        height="49.5655884843353"
                                        width="316.416"
                                      >
                                        <g>
                                          <svg
                                            viewBox="0 0 316.416 49.5655884843353"
                                            height="49.5655884843353"
                                            width="316.416"
                                          >
                                            <g>
                                              <svg
                                                viewBox="0 0 316.416 49.5655884843353"
                                                height="49.5655884843353"
                                                width="316.416"
                                              >
                                                <g>
                                                  <svg
                                                    viewBox="0 0 316.416 49.5655884843353"
                                                    height="49.5655884843353"
                                                    width="316.416"
                                                  >
                                                    <g transform="matrix(1,0,0,1,0,0)">
                                                      <svg
                                                        width="316.416"
                                                        viewBox="0.8500000238418579 -36.5 236.17999267578125 37"
                                                        height="49.5655884843353"
                                                        data-palette-color="#ffffff"
                                                      >
                                                        <path
                                                          d="M29.65-35.5L29.65-32.4 17-32.4 17 0 13.5 0 13.5-32.4 0.85-32.4 0.85-35.5 29.65-35.5ZM39.9 0.5L39.9 0.5Q37.1 0.5 34.7-0.58 32.3-1.65 30.55-3.53 28.8-5.4 27.82-7.85 26.85-10.3 26.85-13.1L26.85-13.1Q26.85-16.75 28.52-19.8 30.2-22.85 33.15-24.68 36.1-26.5 39.85-26.5L39.85-26.5Q43.7-26.5 46.57-24.65 49.45-22.8 51.1-19.78 52.75-16.75 52.75-13.15L52.75-13.15Q52.75-12.75 52.75-12.38 52.75-12 52.7-11.8L52.7-11.8 30.4-11.8Q30.65-9 31.97-6.83 33.3-4.65 35.42-3.38 37.55-2.1 40.05-2.1L40.05-2.1Q42.6-2.1 44.87-3.4 47.15-4.7 48.05-6.8L48.05-6.8 51-6Q50.2-4.15 48.55-2.65 46.9-1.15 44.67-0.33 42.45 0.5 39.9 0.5ZM30.3-14.25L30.3-14.25 49.55-14.25Q49.35-17.1 48.02-19.25 46.7-21.4 44.57-22.63 42.45-23.85 39.9-23.85L39.9-23.85Q37.35-23.85 35.25-22.63 33.15-21.4 31.82-19.23 30.5-17.05 30.3-14.25ZM69.3 0.5L69.3 0.5Q66.45 0.5 64.07-0.58 61.7-1.65 59.92-3.55 58.15-5.45 57.17-7.9 56.2-10.35 56.2-13.1L56.2-13.1Q56.2-16.8 57.85-19.85 59.5-22.9 62.45-24.7 65.4-26.5 69.25-26.5L69.25-26.5Q72.9-26.5 75.7-24.83 78.5-23.15 79.84-20.3L79.84-20.3 76.55-19.25Q75.45-21.25 73.47-22.38 71.5-23.5 69.09-23.5L69.09-23.5Q66.5-23.5 64.34-22.15 62.2-20.8 60.92-18.45 59.65-16.1 59.65-13.1L59.65-13.1Q59.65-10.15 60.95-7.75 62.25-5.35 64.4-3.93 66.55-2.5 69.15-2.5L69.15-2.5Q70.84-2.5 72.42-3.1 74-3.7 75.17-4.73 76.34-5.75 76.75-6.95L76.75-6.95 80.09-5.95Q79.4-4.1 77.77-2.63 76.15-1.15 73.97-0.33 71.8 0.5 69.3 0.5ZM107.34-15.25L107.34 0 103.94 0 103.94-14.55Q103.94-18.95 102.39-21.18 100.84-23.4 97.94-23.4L97.94-23.4Q96.04-23.4 94.17-22.43 92.29-21.45 90.87-19.78 89.44-18.1 88.84-15.95L88.84-15.95 88.84 0 85.44 0 85.44-36.5 88.84-36.5 88.84-20.15Q90.39-23.05 93.17-24.78 95.94-26.5 99.09-26.5L99.09-26.5Q101.34-26.5 102.92-25.7 104.49-24.9 105.47-23.38 106.44-21.85 106.89-19.83 107.34-17.8 107.34-15.25L107.34-15.25ZM118.79 0L115.29 0 115.29-35.5 129.99-35.5Q132.29-35.5 134.22-34.55 136.14-33.6 137.54-31.98 138.94-30.35 139.74-28.38 140.54-26.4 140.54-24.35L140.54-24.35Q140.54-21.45 139.27-18.88 137.99-16.3 135.69-14.7 133.39-13.1 130.29-13.1L130.29-13.1 118.79-13.1 118.79 0ZM118.79-32.4L118.79-16.2 130.14-16.2Q132.24-16.2 133.79-17.35 135.34-18.5 136.19-20.35 137.04-22.2 137.04-24.35L137.04-24.35Q137.04-26.55 136.04-28.4 135.04-30.25 133.42-31.33 131.79-32.4 129.84-32.4L129.84-32.4 118.79-32.4ZM158.69-26.15L158.69-23.05Q155.29-22.95 152.71-21.15 150.14-19.35 149.09-16.2L149.09-16.2 149.09 0 145.69 0 145.69-26.05 148.89-26.05 148.89-19.8Q150.24-22.55 152.46-24.25 154.69-25.95 157.19-26.15L157.19-26.15Q157.69-26.2 158.06-26.2 158.44-26.2 158.69-26.15L158.69-26.15ZM166.64 0L163.24 0 163.24-26.05 166.64-26.05 166.64 0ZM166.64-31.5L163.24-31.5 163.24-36.5 166.64-36.5 166.64-31.5ZM182.68 0.5L182.68 0.5Q179.48 0.5 176.73-0.55 173.98-1.6 171.98-3.75L171.98-3.75 173.38-6.15Q175.58-4.1 177.81-3.18 180.03-2.25 182.53-2.25L182.53-2.25Q185.58-2.25 187.48-3.48 189.38-4.7 189.38-7L189.38-7Q189.38-8.55 188.46-9.38 187.53-10.2 185.81-10.73 184.08-11.25 181.68-11.85L181.68-11.85Q178.98-12.6 177.16-13.43 175.33-14.25 174.41-15.53 173.48-16.8 173.48-18.85L173.48-18.85Q173.48-21.4 174.76-23.08 176.03-24.75 178.26-25.63 180.48-26.5 183.23-26.5L183.23-26.5Q186.23-26.5 188.53-25.55 190.83-24.6 192.28-22.9L192.28-22.9 190.63-20.6Q189.23-22.2 187.31-22.98 185.38-23.75 183.03-23.75L183.03-23.75Q181.43-23.75 179.98-23.33 178.53-22.9 177.61-21.93 176.68-20.95 176.68-19.25L176.68-19.25Q176.68-17.85 177.38-17.07 178.08-16.3 179.48-15.78 180.88-15.25 182.93-14.65L182.93-14.65Q185.88-13.85 188.08-13.03 190.28-12.2 191.48-10.9 192.68-9.6 192.68-7.25L192.68-7.25Q192.68-3.6 189.93-1.55 187.18 0.5 182.68 0.5ZM237.03-15.25L237.03 0 233.63 0 233.63-14.55Q233.63-19.1 232.18-21.25 230.73-23.4 227.88-23.4L227.88-23.4Q224.93-23.4 222.61-21.3 220.28-19.2 219.33-15.9L219.33-15.9 219.33 0 215.93 0 215.93-14.55Q215.93-19.15 214.53-21.28 213.13-23.4 210.23-23.4L210.23-23.4Q207.33-23.4 204.98-21.35 202.63-19.3 201.68-15.95L201.68-15.95 201.68 0 198.28 0 198.28-26.05 201.38-26.05 201.38-20.15Q203.03-23.2 205.61-24.85 208.18-26.5 211.33-26.5L211.33-26.5Q214.58-26.5 216.58-24.65 218.58-22.8 219.03-19.8L219.03-19.8Q220.83-23.1 223.36-24.8 225.88-26.5 229.08-26.5L229.08-26.5Q231.28-26.5 232.81-25.7 234.33-24.9 235.26-23.43 236.18-21.95 236.61-19.88 237.03-17.8 237.03-15.25L237.03-15.25Z"
                                                          opacity="1"
                                                          transform="matrix(1,0,0,1,0,0)"
                                                          fill="#ffffff"
                                                          class="undefined-text-0"
                                                          data-fill-palette-color="primary"
                                                          id="text-0"
                                                        ></path>
                                                      </svg>
                                                    </g>
                                                  </svg>
                                                </g>
                                              </svg>
                                            </g>
                                          </svg>
                                        </g>
                                      </svg>
                                    </g>
                                  </svg>
                                </g>
                              </svg>
                            </g>
                          </svg>
                        </g>
                      </svg>
                      <rect
                        width="395.52"
                        height="247.2"
                        fill="none"
                        stroke="none"
                        visibility="hidden"
                      ></rect>
                    </g>
                  </svg>
                </g>
              </svg>
              {/* <img
                style={{ width: "100%", marginTop: "1rem" }}
                src="/images/logo-color.png"
                alt=""
              /> */}
            </div>
            {/* Card */}
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-duration="2000"
            >
              <div className="content">
                <div style={{ marginLeft: "1rem" }} className="col-lg-11">
                  <h1 className="title">Going Live Soon <div className="dot">.</div></h1>
                  <p>
                    "We are working hard to finish the development of our
                    website."
                  </p>
                  <h6>What We Do:</h6>
                  <p>
                    Anchored in simplicity, We are a company of highly skilled
                    cloud experts, developers, and tech enthusiasts. Our
                    services include an arsenal of IT services from Static
                    Websites to Custom Cloud Native Solutions.
                  </p>
                  <p>For further inqury feel free to Contact us.</p>
                  
                    <a className="contact-us" href="https://calendly.com/cloud-consultation/30min" target="_blank">Schedule a Meeting</a>
                  
                </div>
              </div>
            </div>
            {/* Social Icons */}
            <footer>
              <p>Follow us for more Updates </p>
              <div className="social-media-icons">
                <a
                  href="https://wa.me/971507430574"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fab fa-whatsapp icon"></i>
                </a>

                <a
                  href="https://www.linkedin.com/company/tech-prism/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fab fa-linkedin-in icon"></i>
                </a>

                <a
                  href="https://www.instagram.com/techprismconsultancy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fab fa-instagram icon"></i>
                </a>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
